export function BilibiliBadge(props: {
  mid?: string
  name?: string
  roomId?: number
}) {
  const { mid, name, roomId } = props
  if (!mid) return null

  const url = roomId
    ? `https://live.bilibili.com/${roomId}`
    : `https://space.bilibili.com/${mid}`

  return (
    <a
      className="bilibili-badge-link"
      href={url}
      target="_blank"
      rel="noreferrer"
      onClick={(event) => event.stopPropagation()}
      title={`观看${name ?? mid}的B站直播间`}
      aria-label={`观看${name ?? mid}的B站直播间`}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "var(--cursor-hover)",
        flexShrink: 0
      }}
    >
      <svg width="18" height="18" viewBox="0 0 32 32" aria-hidden="true">
        <rect
          x="6"
          y="0"
          width="5"
          height="9"
          rx="2.5"
          fill="#00A1D6"
          transform="rotate(-28 8.5 4.5)"
        />
        <rect
          x="21"
          y="0"
          width="5"
          height="9"
          rx="2.5"
          fill="#00A1D6"
          transform="rotate(28 23.5 4.5)"
        />
        <rect x="1" y="8" width="30" height="22" rx="6" fill="#00A1D6" />
        <rect x="7" y="13" width="18" height="11" rx="3" fill="#fff" />
        <ellipse cx="12.5" cy="18.5" rx="2.2" ry="3" fill="#00A1D6" />
        <ellipse cx="19.5" cy="18.5" rx="2.2" ry="3" fill="#00A1D6" />
      </svg>
    </a>
  )
}
